export default __webpack_public_path__ + "static/media/staking-bg-web.644b020f.png";